import { BasePluginData } from './base-plugin-data';

/**
 * Represents an access level for user permissions
 */
export interface AccessLevel {
  id: string;
  name: string;
  description: string;
}

/**
 * Represents built-in roles for a cloud provider
 */
export interface BuiltInRoles {
  read: string;
  write: string;
  admin: string;
}

/**
 * Represents cloud provider specific mappings
 */
export interface ProviderMapping {
  name: string;
  builtInRoles: BuiltInRoles;
}

/**
 * Represents user account configuration for cloud resources
 */
export class UserAccountData extends BasePluginData {
  override get pluginStepName(): string { return 'UserAccountData'; }

  /**
   * Generic access levels that apply across all cloud providers
   */
  accessLevels: AccessLevel[] = [
    {
      id: 'read',
      name: 'Read Only',
      description: 'View and read access only'
    },
    {
      id: 'write',
      name: 'Read/Write',
      description: 'Read and modify access'
    },
    {
      id: 'admin',
      name: 'Administrator',
      description: 'Full administrative access'
    }
  ];

  /**
   * Cloud provider mappings with built-in roles - Only Azure supported
   */
  providerMappings: Record<string, ProviderMapping> = {
    azure: {
      name: 'Microsoft Azure',
      builtInRoles: {
        read: 'Reader',
        write: 'Contributor',
        admin: 'Owner'
      }
    }
  };

  /**
   * User selections for the wizard
   */
  selectedCloudProvider?: string;
  selectedAccessLevel?: string;
}
